<script setup>
import { computed } from "vue"

const props = defineProps({
  generando: { type: Boolean, default: false },
  pdfUrl: { type: String, default: null },
  error: { type: String, default: "" }
})

// Mismo patrón que src/views/quote/List.vue: el link guardado es el de
// "ver" en Drive; el de descarga directa se deriva del id del archivo.
const descargaUrl = computed(() => {
  if (!props.pdfUrl) return null
  const match = props.pdfUrl.match(/\/d\/([^/]+)/)
  if (!match) return props.pdfUrl
  return `https://drive.google.com/uc?export=download&id=${match[1]}`
})
</script>

<template>
  <div class="mt-3">
    <div v-if="generando" class="alert alert-info d-flex align-items-center gap-2 mb-0">
      <span class="spinner-border spinner-border-sm"></span>
      Generando cotización en PDF, esto puede tardar un momento…
    </div>

    <div v-else-if="error" class="alert alert-danger mb-0">
      {{ error }}
    </div>

    <div v-else-if="pdfUrl" class="alert alert-success d-flex align-items-center justify-content-between gap-2 mb-0">
      <span>Cotización generada correctamente.</span>
      <div class="d-flex gap-2">
        <a :href="pdfUrl" target="_blank" class="btn btn-sm btn-primary">Ver PDF</a>
        <a :href="descargaUrl" class="btn btn-sm btn-dark" title="Descargar PDF">
          <i class="bi bi-download"></i>
        </a>
      </div>
    </div>
  </div>
</template>
